module.exports = __webpack_public_path__ + "img/KEN_agriExpansionGreenChg_2020.5f83a0a1.jpg";